import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { UtilsService } from "src/app/domain/services/utils.service";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import { LoginAuthenticationRequest } from "../interfaces/login.interface";

@Injectable({
	providedIn: "root"
})
export class LoginService {
	token = "";
	token2FA = "";
	constructor(
		private http: HttpClient,
		private router: Router,
		private utilService: UtilsService,
		private retornoStatus: RetornaDadosRequest
	) {}

	login(loginAuthentication: LoginAuthenticationRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/access/authenticate`, loginAuthentication).pipe(
			tap(res => {
				localStorage.removeItem("token");
				localStorage.setItem("token", res.data.token);
				//Integração Safe2Go
				localStorage.setItem("vinculoCorretora", res.data.vinculoCorretora);
				var notification = localStorage.getItem("notification");
				var notifications = notification == null ? [] : (JSON.parse(notification) as Array<any>);
				res.message.forEach(n => {
					var index = notifications.findIndex(i => i == n.message);
					if (index == -1) {
						notifications.push(n.message);
					}
				});
				localStorage.setItem("notification", JSON.stringify(notifications));
				if (res.data.vinculoCorretora) {
					localStorage.setItem("userAndBrokerData", JSON.stringify(res.data.userandBrokerData));
				}
				return res;
			})
		);
	}

	isAuthenticated2FA(): Observable<any> {
		return this.http.get(`${environment.urlApi}/access/isAuthenticated2FA`);
	}

	authentication2FA(loginAuthentication: LoginAuthenticationRequest, token: string): Observable<any> {
		this.token2FA = token;

		return this.http.post<any>(`${environment.urlApi}/access/authenticate2FA`, loginAuthentication).pipe(
			tap(res => {
				return res;
			})
		);
	}

	resendToken2FA(login: string): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/access/resendToken2FA`, login).pipe(
			tap(res => {
				return res;
			})
		);
	}

	isLoggedIn(): boolean {
		this.token = localStorage.getItem("token");
		return this.token !== null;
	}

	handleLogin() {
		this.router.navigate(["/login"]);
	}

	decodeToken(token: string) {
		try {
			var decode = JSON.parse(this.b64_to_utf8(token.split(".")[1]));
			decode.name = this.b64_to_utf8(decode.name);
			decode.userNameRedis = this.b64_to_utf8(decode.userNameRedis);
			return decode;
		} catch (e) {}
	}

	b64_to_utf8(str) {
		return decodeURIComponent(escape(window.atob(str)));
	}

	downloadPrivacyPolicyFile(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/document/GetPrivacyPolicy`);
	}

	downloadFraudPreventionFile(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/document/GetFraudPrevention`);
	}

	logout() { 
		localStorage.removeItem("token"); 
		localStorage.removeItem("vinculoCorretora"); 
		localStorage.removeItem("notification"); 
		localStorage.removeItem("home"); 
		localStorage.removeItem("profileClaim"); 
		localStorage.removeItem("propostas"); 
		
		// Redireciona para a tela de login 
		this.router.navigate(['/login']);
	}
}